import type { StatsSnapshot } from './gameplay-snapshot';
import { useCurrencyStore } from '../store/zustand/useCurrencyStore';
import { sumAll } from '@game-libs/exc-libs/src/helpers/array.helpers';
import { unitStats as stats } from './index';

export const updateClericStats = (state: StatsSnapshot) => {
  const upgrades = state.upgrades.cleric;
  const cleric = state.generators.cleric;

  const currency = useCurrencyStore.getState();
  const inspirationMultiplier = currency.inspiration.remainingActive > 0 ? currency.inspiration.multiplier : 1;

  const generatedUnits = cleric.owned * cleric.baseGeneration * inspirationMultiplier;

  const unitsGeneration = sumAll([generatedUnits]);

  // heroResources adds critical chance for generating additional units
  const criticalChance = upgrades.heroResources?.multiplier ?? 0;

  stats.cleric = {
    mainIndividualGenerationStat: cleric.baseGeneration,
    unitsGeneration: unitsGeneration,
    criticalChance: criticalChance,
  };
};
